import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { LinkProvider } from './LinkProvider';
import Header from "./components/Header";
import Footer from "./components/Footer";
import PageTransition from "./components/PageTransition";
import Home from "./pages/Home";
import Markets from "./pages/Markets";
import Trading from "./pages/Trading";
import Accounts from "./pages/Accounts";
import Security from "./pages/Security";
import WhyUs from "./pages/WhyUs";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Home /></PageTransition>} />
        <Route path="/markets" element={<PageTransition><Markets /></PageTransition>} />
        <Route path="/trading" element={<PageTransition><Trading /></PageTransition>} />
        <Route path="/accounts" element={<PageTransition><Accounts /></PageTransition>} />
        <Route path="/security" element={<PageTransition><Security /></PageTransition>} />
        <Route path="/why-us" element={<PageTransition><WhyUs /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <LinkProvider>
      <Router>
        <div className="overflow-x-hidden">
          <Header />
          <AnimatedRoutes />
          <Footer />
        </div>
      </Router>
    </LinkProvider>
  );
}

export default App;
